import { Box as Container } from '@mui/material'
import React from 'react'
import { FormProvider, UseFormReturn } from 'react-hook-form'

type FormProps = {
  methods: UseFormReturn<any, any, undefined>
  children: React.ReactNode
  onSubmit: (data: any) => void
  onKeyDown?: (e: any) => void
}

export const Form: React.FC<FormProps> = ({ methods, children, onSubmit, onKeyDown }) => {
  return (
    <Container sx={{ width: '100%' }}>
      <FormProvider {...methods}>
        <form onSubmit={onSubmit} onKeyDown={onKeyDown}>
          {children}
        </form>
      </FormProvider>
    </Container>
  )
}
